import React from 'react';

import { isPast } from 'date-fns';

import { useLocale } from 'state/intl';
import { formatTime, t } from 'state/intl/translations';
import { useServiceModeLive } from 'state/service-mode';
import { ServiceMode } from 'state/service-mode/types';
import { formatLocalizedCurrentWeekDay, formatLocalizedDate } from 'utils/dateTime';

import {
  ArrowRightIcon,
  CalendarIcon,
  CardWrapper,
  DateLabel,
  DateTimeWrapper,
  DateWrapper,
  DayLabel,
  SectionTitle,
  SectionWrapper,
  TimeLabel,
  TimeWrapper,
} from './styled';
import { IFutureOrderTimeCard } from './types';

export const FutureOrderTimeCard = ({
  dateString,
  showIcon = false,
  onPress,
}: IFutureOrderTimeCard) => {
  const { language } = useLocale();
  const serviceMode = useServiceModeLive();

  const dateConverted = new Date(dateString);

  if (isPast(dateConverted)) {
    return null;
  }

  const sectionTitle =
    serviceMode === ServiceMode.DELIVERY ? t('prepDeliveryTime') : t('prepPickUpTime');

  const dateFormatted = formatLocalizedDate({ dateTime: dateConverted, language });
  const dateTimeFormatted = formatTime(dateConverted);
  const dayFormatted = formatLocalizedCurrentWeekDay({
    dateTime: dateConverted,
    language,
  });

  const handleCardPress = () => {
    onPress && onPress();
  };

  return (
    <SectionWrapper onPress={handleCardPress}>
      <SectionTitle>{sectionTitle}</SectionTitle>
      <CardWrapper>
        <CalendarIcon />
        <DateTimeWrapper>
          <DateWrapper>
            <DayLabel>{dayFormatted}</DayLabel>
            <DateLabel>{dateFormatted}</DateLabel>
          </DateWrapper>
          <TimeWrapper>
            <TimeLabel>{dateTimeFormatted}</TimeLabel>
          </TimeWrapper>
        </DateTimeWrapper>
        {showIcon && <ArrowRightIcon />}
      </CardWrapper>
    </SectionWrapper>
  );
};
